import type { MarketplaceFilterAction, MarketplaceFilters } from "../../hooks/useMarketplaceFilters";
import { Button } from "../ui/Button";

interface ListingFiltersProps {
  filters: MarketplaceFilters;
  resultCount: number;
  dispatch: (action: MarketplaceFilterAction) => void;
}

const filterButtons = [
  { label: "Shortage items", active: (filters: MarketplaceFilters) => filters.shortageOnly, action: { type: "toggleShortageOnly" } as const },
  { label: "Brands only", active: (filters: MarketplaceFilters) => filters.brandOnly, action: { type: "toggleBrandOnly" } as const },
  { label: "Packet ready", active: (filters: MarketplaceFilters) => filters.packetReady, action: { type: "togglePacketReady" } as const },
];

export function ListingFilters({ filters, resultCount, dispatch }: ListingFiltersProps) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 ">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex flex-wrap gap-2">
          {filterButtons.map(filter => {
            const active = filter.active(filters);
            return (
              <button
                aria-pressed={active}
                className={`rounded-full border px-4 py-2 text-sm font-bold transition ${active ? "border-slate-400 bg-slate-200 text-slate-950" : "border-slate-200 text-slate-700 hover:bg-slate-100"}`}
                key={filter.label}
                onClick={() => dispatch(filter.action)}
                type="button"
              >
                {filter.label}
              </button>
            );
          })}
          <button
            aria-pressed={Boolean(filters.shipsWithinHours)}
            className={`rounded-full border px-4 py-2 text-sm font-bold transition ${filters.shipsWithinHours ? "border-slate-400 bg-slate-200 text-slate-950" : "border-slate-200 text-slate-700 hover:bg-slate-100"}`}
            onClick={() => dispatch({ type: "setShipsWithinHours", hours: filters.shipsWithinHours ? undefined : 24 })}
            type="button"
          >
            Within 24 hrs
          </button>
        </div>
        <div className="flex items-center gap-3 text-sm text-slate-600">
          <strong className="text-slate-950">{resultCount} results</strong>
          <Button variant="ghost" onClick={() => dispatch({ type: "reset" })}>Reset</Button>
        </div>
      </div>
    </div>
  );
}
